module.exports = __webpack_public_path__ + "img/pic22.e78f0606.jpg";